<template>
    <div style="background:#fff">
        <div style="width:1400px; margin:0 auto; padding:10px 0;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item>{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item>{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="l20home_ctrl_container l20home">
            <div class="ctrl_bg"></div>
            <!-- 标题 -->
            <div class="l20home_ctrl_title">
                <!-- 刷新按钮 -->
                <div class="refresh_btn" title="刷新" @click="refresh"><a-icon type="sync" /></div>
            </div>

            <div class="board">
                <div class="board-item"  v-for="day in datas.board">
                    <p class="dt">{{ day.dt }}</p>
                    <template v-if="" v-for="it in day.data">
                    <span>{{it.title}}：{{it.value}}</span>
                    </template>
                </div>
            </div>

            <!-- 表格 -->
            <div class="l20home_ctrl_tables" v-for="(it,index) in datas.results" :key="`table${index}`" >
                <div class="table_title">
                    <h2>{{ it.title }}</h2>
                </div>
                <DataTable :fields="it.thead" :datas="it.tbody" class="l20home_ctrl_table" :paging="false"/>
                <div class="tips">
                    <p v-for="t in it.tips" :key="t">{{ t }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import DataTable from '@/components/common/datatable.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'l20home',
    props: ['parent', 'name'],
    components: {
        DataTable,
    },
    mounted(){
        this.getData()
        
        this.timer.normal = setInterval(() => {
            this.getData(0, false)
        }, 60 * 60 * 1000)
    },
    beforeDestroy() {
        clearInterval(this.timer.normal)
    },
    data() {
        return {
            datas: {
                board: [],
                results: [],
            },
            timer: {
                normal: null
            }
        }
    },
    methods: {
        getData() {
            this.loading = true
            let params = {mode:'home'}
            this.$service.query(this.queryId, params).then((data)=>{
                Object.assign(this.datas, data)
                this.loading = false
            }).catch((data)=> {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        }
    }
}
</script>
<style lang="less">
    .l20home_ctrl_table {
        .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
            padding:5px 0;
        }
        .ant-table-tbody > tr:nth-child(2n) td{
            background:#f5efe0;
        }
        .ant-table-tbody > tr:hover td{
            background:#e6f7ff;
        }
        .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
            padding: 5px 0px;
        }
    }
</style>
<style lang="less" scoped>
@width:1500px;

// 刷新按钮动画
@keyframes scale {
    0% {
        transform: scale(1);
        opacity: .7
    }
    50% {
        transform: scale(1.5);
        opacity: 0
    }
    99% {
      transform: scale(1);
      opacity: 0
    }
    100% {
        transform: scale(1);
        opacity: .7
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg)
    }
}

.l20home_ctrl_container {
    min-height: 700px;
    .l20home_ctrl_content_container {
        width:@width;
        margin:0 auto;
    }
    .l20home_ctrl_title {
        height:100px;
        width:100%;
        margin:0 0 40px 0;
        .refresh_btn {
            position:absolute;
            left: 50%;
            margin:25px 0 0 250px;
            width: 50px;
            height: 50px;
            text-align: center;
            cursor: pointer;
            border-width: 0;
            background-color: transparent;
            color: rgba(0, 0, 0, .3);

            i {
                font-size: 25px;
                line-height: 55px;
            }
            &:hover {
                animation: spin 2s infinite linear;
            }
            &:hover:after {
                animation: none;
            }
            &:after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 50px;
                width: 50px;
                border-radius: 100%;
                border: 1px solid rgba(0, 0, 0, .3);
                animation: scale 2s ease infinite;
            }
        }
    }

    .l20home_ctrl_tables {
        margin:0 auto;
        margin-top:20px;
        margin-bottom:30px;
        width: @width;
        .table_title {
            position: relative;
            text-align: center;
            margin:50px 0 30px 0;
            h2 {
                color: #a89371; 
                font-size:20px;
                &:before {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    left:0;
                    width:30%;
                    border-bottom: 1px solid #a89371;
                }
                &:after {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    right:0;
                    width:30%;
                    border-bottom: 1px solid #a89371;
                }
            }
        }
        .tips {
            margin:20px 0 0 0;
            color:#777;
            text-align: center;
        }
    }

    &.l20home {
        background: url('../../../assets/img/ctrl/l20/bg.jpg') center -100px no-repeat;
        overflow: hidden;
        .l20home_ctrl_title {
            background: url('../../../assets/img/ctrl/l20/title.png') center no-repeat;
        }
    }

    @mainColor: #a89371;
    .board {
        width: @width;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        margin: 0 auto 30px;
        padding: 20px;
        border: 1px solid @mainColor;
        background:rgba(255,255,255,0.7);
        .legend {
            position: absolute;
            width: 18px;
            line-height: 1;
            left: -19px;
            top: -4px;
            min-height: 40px;
            padding: 2px;
            background-color: @mainColor;
            color: #fff;
        }
        .corner {
            @cornerWidth: 4px;
            position: absolute;
            height: @cornerWidth;
            width: 40px;
            background-color: @mainColor;
            &:after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 40px;
            width: @cornerWidth;
            background-color: @mainColor;
            }
            &:nth-of-type(1) {
            top: -@cornerWidth;
            left: -@cornerWidth;
            }
            &:nth-of-type(2) {
            bottom: -@cornerWidth;
            right: -@cornerWidth;
            transform: rotate(180deg);
            }
        }
    }
    .board-item {
        vertical-align: top;
        width:187px;
        min-height:150px;
        padding-bottom: 10px;
        margin:10px;
        background:rgba(200,200,200,0.1);
        color: #777;
        position: relative;
        .server {
            position: absolute;
            right: -6px;
            top: -6px;
            padding: 3px;
            background-color: #c40000;
            color: #fff;
            border-radius: 12px;
            font-size: 12px;
            line-height: 1;
        }
        .dt {
            width: 100%;
            height: 60px;
            margin-bottom: 20px;
            margin-left: 0;
            background-color: #f4ebdc;
            color: @mainColor;
            font-size: 18px;
            line-height: 60px;
            text-align: center;
        }
        p {
            margin-left: 15px;
            margin-right: 15px;
            line-height:24px;
            color:#777;
        }
    }
    .board-item span{line-height:24px;  display:block; padding: 0 20px}
}
</style>